<div class="" [style.min-height]="viewportHeight" style="display: block">
  <app-hero />
  <app-job-listing />
  <app-categories [countryOrigin]="setCountryOrigin" />
  @if (siteData.lander.youtubeHolder.isShow) {
    <app-video-holder />
  }
  @if (siteData.lander.careersForLife.isShow) {
    <app-careers-life [countryOrigin]="setCountryOrigin"
     />
  }
  @if (siteData.lander.careersHint.isShow) {
    <app-recruit-tips />
  }
</div>

<nz-modal
  [(nzVisible)]="isShowModal"
  (nzOnCancel)="isShowModal = false"
  [nzCloseIcon]="closeIcon"
  [nzFooter]="null"
  nzCentered
  nzWrapClassName="signup-question-modal"
  nzWidth="600px"
  nzMaskClosable="false"
  nzKeyboard="false"
  >
  <ng-template #closeIcon>
    <span class="GA-onboarding-close-modal">
      <i nz-icon nzType="close"></i>
    </span>
  </ng-template>
  <ng-container *nzModalContent>
    <div class="signup-question">
      <img src="../../assets/images/expertise-digital-marketing-header.svg" alt="Signup Questions" />
      <h2> Shape your next career move. </h2>
      <p>
        Share the industries, roles, and setups you're interested in - we'll use<br />
        your preferences to match you with relevant job opportunities.
      </p>
      <br />
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        class="GA-proceed-on-boarding"
        (nzClick)="isShowModal = false"
        [routerLink]="['/questions']"
        >
        Get Started
      </button>
    </div>
  </ng-container>
  <div *nzModalFooter></div>
</nz-modal>
